import { apiClient, type PageData } from './client'

export type AuditResult = 'success' | 'failed'

export interface AuditLog {
	id: number
	created_at: string
	operator_id: number
	operator_username: string
	operator_nickname: string
	operator_is_super_admin: boolean
	module: string
	module_label: string
	action: string
	action_label: string
	resource_type: string
	resource_id: string
	resource_no: string
	summary: string
	before_data: Record<string, unknown> | null
	after_data: Record<string, unknown> | null
	metadata: Record<string, unknown> | null
	ip: string
	user_agent: string
	request_id: string
	result: AuditResult
	error_message: string
}

export interface AuditOption {
	value: string
	label: string
}

export interface AuditOptions {
	modules: AuditOption[]
	actions: AuditOption[]
}

export interface AuditLogQuery {
	page: number
	page_size: number
	operator_id?: number
	module?: string
	action?: string
	resource_type?: string
	resource_no?: string
	result?: AuditResult
	start_time?: string
	end_time?: string
}

export const auditApi = {
	listLogs: async (query: AuditLogQuery): Promise<PageData<AuditLog>> => {
		const params = new URLSearchParams()
		Object.entries(query).forEach(([key, value]) => {
			if (value !== undefined && value !== '') {
				params.set(key, String(value))
			}
		})
		const response = await apiClient.get<PageData<AuditLog>>(`/audit/logs?${params.toString()}`)
		return response.data
	},
	listOptions: async (): Promise<AuditOptions> => {
		const response = await apiClient.get<AuditOptions>('/audit/options')
		return response.data
	},
}
